
import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';
import { boxShadow } from 'constants/utilsStyles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: ${boxShadow};
  margin: 0 10px;
  border-radius: 13px;
  padding: 10px 0 0 0;
  .contact-inner-skeleton {
    padding: 10px 0 0 0;
  }
`;
type Props = {
  listView?: boolean,
} & typeof defaultProps;

const defaultProps = {
  listView: false,
};

const ContactCardSkeleton = function ContactCardSkeleton(props: Props) {
  const { listView } = props;
  console.log('listView', listView);

  return (
    <Wrapper className='contact-card-skeleton d-flex-column-center'>
      <SkeletonCustom
        height='135px'
        width='135px'
        diameter='50%'
      />
      <div className='contact-inner-skeleton d-flex-column-center'>
        <div className='d-flex-column-center mb-c-10'>
          <SkeletonCustom
            height='30px'
            width='130px'
            diameter='6px'
            margin='0 0 5px 0'
            marginSm='0 0 5px 0'
          />
          <SkeletonCustom
            height='30px'
            width='180px'
            diameter='6px'
            margin='0 0 5px 0'
            marginSm='0 0 5px 0'
          />
        </div>
        <div className='d-flex-column-center mb-c-10'>
          <SkeletonCustom
            height='20px'
            width='130px'
            diameter='23px'
            margin='0 0 5px 0'
            marginSm='0 0 5px 0'
          />
          <SkeletonCustom
            height='20px'
            width='130px'
            diameter='23px'
            margin='0 0 5px 0'
            marginSm='0 0 5px 0'
          />
        </div>
      </div>
    </Wrapper>
  );
};
ContactCardSkeleton.defaultProps = defaultProps;
export default ContactCardSkeleton;